import {
  Grid,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  TextField
} from '@material-ui/core';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PropTypes from 'prop-types';

export const LRU_OPTIONS_TITLE = 'General Settings';
const defaultDiskImageRepo =
  'gitdock.panasonic.aero:4567/automation/kubevirt/kubevirt-resources/vmidisks/external';
const defaultVMNameHelperText = 'The name of the VM';
export const vmNameExistsError = 'This VM name has already been added, please choose a new vm name';

// checks if the vm name is valid
export function ValidVMName(newName, addedVMList) {
  return !addedVMList.some((vm) => vm.name === newName);
}

VMGeneralSettings.propTypes = {
  currentVM: PropTypes.object,
  updateCurrentVM: PropTypes.func,
  addedVMList: PropTypes.array
};

export function VMGeneralSettings({ currentVM, updateCurrentVM, addedVMList }) {
  const isValidVMName = ValidVMName(currentVM.name, addedVMList);
  const vmNameHelperText = isValidVMName ? defaultVMNameHelperText : vmNameExistsError;
  const vmNameError = !isValidVMName;

  const handleNameChange = (event) => {
    const newName = event.target.value;
    const updatedVM = {
      ...currentVM,
      name: newName
    };
    updateCurrentVM(updatedVM);
  };

  const handleArchChange = (event) => {
    const newImageTag = `${currentVM.value}-${event.target.value}-master`;
    const updatedVM = {
      ...currentVM,
      image: `${defaultDiskImageRepo}:${newImageTag}`,
      architecture: event.target.value
    };
    updateCurrentVM(updatedVM);
  };

  const handleReplicasChange = (event) => {
    const updatedVM = {
      ...currentVM,
      replicas: event.target.value
    };
    updateCurrentVM(updatedVM);
  };

  return (
    <Grid item xs={12}>
      <Accordion defaultExpanded data-testid="vm-general-settings">
        <AccordionSummary sx={{ paddingLeft: 0 }} expandIcon={<ExpandMoreIcon />}>
          <Typography variant="h6">{LRU_OPTIONS_TITLE}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container item xs={12} spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                data-testid="vm-name"
                label="VM Name"
                variant="outlined"
                fullWidth
                value={currentVM.name}
                helperText={vmNameHelperText}
                onChange={handleNameChange}
                error={vmNameError}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel id="arch-select-label">Architecture</InputLabel>
                <Select
                  labelId="arch-select-label"
                  id="arch-select"
                  value={currentVM?.architecture}
                  label="Architecture"
                  onChange={handleArchChange}
                >
                  {currentVM.availableArch.map((arch) => (
                    <MenuItem key={arch} value={arch}>
                      {arch}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormHelperText>The architecture for the VM</FormHelperText>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel id="replicas-select-label">Replicas</InputLabel>
                <Select
                  labelId="replicas-select-label"
                  id="replicas-select"
                  value={currentVM?.replicas}
                  label="Replicas"
                  onChange={handleReplicasChange}
                >
                  {Array.from({ length: currentVM.maxReplicas }, (_, i) => (
                    <MenuItem key={i + 1} value={i + 1}>
                      {i + 1}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormHelperText>How many instances of this VM to deploy</FormHelperText>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
}
